export const paginaitonFilter = [
  { name: "lmit", type: "number", defaultValue: 30 },
  { name: "page", type: "number", defaultValue: 1 },
  { name: "order", type: "number", defaultValue: -1 },
  { name: "orderBy", type: "string", defaultValue: "updatedAt" },
];

export const privateListingFilters = [
  ...paginaitonFilter,
  { name: "category", type: "string", defaultValue: "" },
];

export const mainStoriesListingFilters = [
  ...paginaitonFilter,
  { name: "category", type: "string", defaultValue: "" },
  { name: "search", type: "string", defaultValue: "" },
];

export const savedStoriesListingFilters = [
  ...paginaitonFilter,
  { name: "category", type: "string", defaultValue: "" },
];

export const myStoriesListingFilters = [
  ...paginaitonFilter,
  { name: "category", type: "string", defaultValue: "" },
];
